<template>
  <div class="fee-confirm-component">
    <CollapsePanel style="padding: 0" v-model="showChart">
      <div slot="title">
        <span class="rectangle" style="background:#f09537"></span>
        月账单支付情况（账期:{{ accountPeriod }}天）
      </div>
      <div>
        <div class="chart-head">
          <div class="legend">
            <div class="legend-item">
              <span
                class="color-area"
                style="
                  background-image: linear-gradient(to right, #ddfae4, #27b148);
                "
              ></span>
              <span class="legend-title">已支付</span>
            </div>
            <div class="legend-item">
              <span
                class="color-area"
                :style="{ backgroundColor: chartColorTheme[1] }"
              ></span>
              <span data-v-82e36644="" class="legend-title">逾期未支付</span>
            </div>
            <div class="legend-item">
              <span
                class="color-area"
                :style="{ backgroundColor: chartColorTheme[2] }"
              ></span>
              <span data-v-82e36644="" class="legend-title">待支付</span>
            </div>
          </div>
        </div>
        <div style="font-size: 12px; color: #000">月账单总金额</div>
        <div>
          <div @click="() => {}">
            <div id="fee-confirm-chart" ref="chartEle"></div>
            <span></span>
          </div>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
      </div>
    </CollapsePanel>
  </div>
</template>

<script>
import CollapsePanel from "@/components/place-order/collapse-panel"
import echarts from "@moon-land/echarts/lib/echarts"
import "@moon-land/echarts/lib/chart/bar"
import "@moon-land/echarts/lib/component/grid"
import "@moon-land/echarts/lib/component/dataZoom"
import "@moon-land/echarts/lib/component/markLine"
import "@moon-land/echarts/lib/component/tooltip"
import "@moon-land/echarts/lib/component/legend"
import dayjs from "dayjs"
import util from "@/libs/util";
import _ from "lodash"
import { chartData } from "./data.js"

import { monthlyBill } from "@/api/feeConfirmation"

let chartInstance = null

window.onresize = () => {
  chartInstance && chartInstance.resize()
}

const maxWith = window.innerWidth
function chartDisplayPercent(dateRange) {
  let ratio = 1
  if (dateRange === 2) {
    ratio = 0.9
  } else if (dateRange === 3) {
    ratio = 1
    return 100
  }

  let result = 100
  if (maxWith >= 1500) {
    result = 100
  } else if (maxWith >= 1200) {
    result = 80
  } else if (maxWith >= 1000) {
    result = 65
  }

  return result * ratio
}

const COLOR_THEME = ["#cdcdcd", "#f00", "#3fb1e3"]
const COLOR_GREEN = [
  "#27b148",
  "#52cc6f",
  "#7ee697",
  "#ddfae4",

  "#27b148",
  "#52cc6f",
  "#7ee697",
  "#ddfae4",

  "#27b148",
  "#52cc6f",
  "#7ee697",
  "#ddfae4",

  "#27b148",
  "#52cc6f",
  "#7ee697",
  "#ddfae4",

  "#27b148",
  "#52cc6f",
  "#7ee697",
  "#ddfae4",

  "#27b148",
  "#52cc6f",
  "#7ee697",
  "#ddfae4",
  
]
const WEEK_DAY = {
  1: "周一",
  2: "周二",
  3: "周三",
  4: "周四",
  5: "周五",
  6: "周六",
  7: "周日",
}

export default {
  components: {
    CollapsePanel,
  },
  mounted() {
    window.onresize = () => {}
    const [fromDate, toDate] = this.genMonthRange(this.dateRange)
    monthlyBill({
        fromDate,
        toDate,
      }).then(res=>{

        if (res.data.success){
          let data =JSON.parse(res.data.data.value)
           console.log('====>',data)
          this.renderChart(data)
        }
      })
    // this.renderChart(chartData) // 测试数据
  },
  data() {
    return {
      loading: false,
      chartColorTheme: COLOR_THEME,
      showChart: true,
      COLOR_THEME: COLOR_THEME,
      dateRange: 24,
      accountPeriod: 0,
      series: [],
      billingReportPaymentStatisticsDTOS: [],
      totlePrice: []
    }
  },
  methods: {
    async renderChart(payload = {}) {
      const chartEle = this.$refs.chartEle
      chartInstance = echarts.init(chartEle)
      this.loading = true
      const dateRange = this.dateRange
      const { accountPeriod, currencyList, billingReportPaymentStatisticsSummaryDTOs = [] } = payload
      this.accountPeriod = accountPeriod
      let writeLength = 0
      let flag = true
      this.showChart =false

      const billingReportPaymentStatisticsDTOS = []
      billingReportPaymentStatisticsSummaryDTOs.forEach(item => {
        item.billingReportPaymentStatisticsDTOs.forEach(item1 => {
          billingReportPaymentStatisticsDTOS.push({
            billingCycle: item.billingCycle,
            ...item1
          })
        })
      })
      this.billingReportPaymentStatisticsDTOS = billingReportPaymentStatisticsDTOS

      billingReportPaymentStatisticsDTOS.forEach((v, index) => {
        v.date = v.billingCycle
        v.unWriteOffRecordAllRed = 0
        v.unWriteOffRecordAll = 0
        if (writeLength < v.writeOffRecord.length) {
          writeLength = v.writeOffRecord.length
        }

        v.writeOffRecord.forEach((i, index1) => {
          v["amount" + index1] = i.amount
        })
        v.unWriteOffRecord.forEach((j) => {
          if (v.isOverdue) {
            v.unWriteOffRecordAllRed += j.amount ?j.amount :0
          } else {
            v.unWriteOffRecordAll +=j.amount ?j.amount :0
          }
        })
        if (v.theoreticDueDate&&!dayjs(v.theoreticDueDate).isBefore(dayjs()) && flag) {
          flag = false
          v.showSplitLine = true
        }
        if(v.receivableAmount) this.totlePrice.push(util.spliceCurrencySymbolAndCost(v.currency, v.receivableAmount))
        else this.totlePrice.push(0)
        v.receivableAmount ? this.showChart = true : ''
      })
      console.log(this.totlePrice, "======>》", billingReportPaymentStatisticsDTOS)
      for (let i = 0; i < writeLength; i++) {
        this.series.push({
          name: "已支付",
          data: billingReportPaymentStatisticsDTOS.map((v) => v["amount" + i] || 0),
          itemStyle: {
            color: COLOR_GREEN[i % 4],
          },
        })
      }
      this.series.push({
          name: "逾期未支付",
          data: billingReportPaymentStatisticsDTOS.map(
            (v) => v.unWriteOffRecordAllRed
          ),
          itemStyle: {
            color: COLOR_THEME[1],
          },
          markPoint:{
            // label: {
            //   position: "bottom",
            //   show: true,
            //   color: '#000',
            //   formatter: (e) => {
            //     return '账期已到'
            //   }
            // },
          }
        },
        {
        name: "待支付",
        data: billingReportPaymentStatisticsDTOS.map(
          (v) => v.unWriteOffRecordAll
        ),
        itemStyle: {
          color: COLOR_THEME[2]
        },
        markLine: {
          silent: true,
          symbol: ["none", "none"],
          lineStyle: {
            type: "solid",
          },
          label:{
            distance:15,
          },
          data: this.setMarklineData(),
        },
      })
      console.log("this.series", this.series)
      let totalData = []
      const dataMap = _.keyBy(billingReportPaymentStatisticsDTOS, "date")
      console.log("===>dataMap", dataMap)
      this.loading = false
      chartInstance.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              show:false,
              formatter: (params) => {
                if (params.seriesData.length === 0) {
                  window.mouseCurValue = params.value
                }
              },
            },
            crossStyle:{
              opacity:0
            }
          },
          formatter: (params) => {
            let res = "",
              sum = 0
            for (let i = 0; i < params.length; i++) {
              let series = params[i]
              series.data === undefined ? series.data = 0 : series.data = series.data
              sum += Number(series.data)
              if (sum >= window.mouseCurValue) {
                res = `${series.marker}${series.axisValue}${series.seriesName}<br/>`
                if (series.seriesName === "待支付" && series.data) {
                  let unHtml = ""
                  billingReportPaymentStatisticsDTOS[
                    series.dataIndex
                  ].unWriteOffRecord.forEach((i) => {
                    if (i.invoiceTitle) {
                      unHtml += `待付抬头：${i.invoiceTitle}<br/>待付金额：${util.spliceCurrencySymbolAndCost(billingReportPaymentStatisticsDTOS[series.dataIndex].currency, i.amount)}<p style="margin-bottom:10px"></p>`
                    } else {
                      unHtml += `未开票待付金额：${util.spliceCurrencySymbolAndCost(billingReportPaymentStatisticsDTOS[series.dataIndex].currency, i.amount)}<p style="margin-bottom:10px"></p>`
                    }
                  })
                  res += unHtml
                } else if (series.seriesName === "逾期未支付" && series.data) {
                  let unHtml = ""
                  billingReportPaymentStatisticsDTOS[
                    series.dataIndex
                  ].unWriteOffRecord.forEach((i, index) => {
                    unHtml += `逾期未支付抬头：${
                      i.invoiceTitle
                    }<br/>逾期未支付金额：${util.spliceCurrencySymbolAndCost(billingReportPaymentStatisticsDTOS[series.dataIndex].currency, i.amount)}<p style="margin-bottom:10px"></p>`
                  })
                  res += unHtml
                } else if (series.seriesName === "已支付" && series.data) {
                  let writeOffRecord = billingReportPaymentStatisticsDTOS[
                    series.dataIndex
                  ].writeOffRecord
                  let arrLength = params.length - 2 - writeOffRecord.length
                  writeOffRecord.push(...new Array(arrLength).fill(0))
                  writeOffRecord.forEach((i, index) => {
                    if (writeOffRecord.length > 1) {
                      if (index == series.componentIndex) {
                        res += `付款抬头：${i.invoiceTitle}<br/>付款金额：${util.spliceCurrencySymbolAndCost(billingReportPaymentStatisticsDTOS[series.dataIndex].currency, i.amount)}<br/>付款日期：${i.writeOffTime}<br/>实际账期：${i.actualAccountPeriod}`
                      }
                    } else {
                      res += `付款抬头：${i.invoiceTitle}<br/>付款金额：${util.spliceCurrencySymbolAndCost(billingReportPaymentStatisticsDTOS[series.dataIndex].currency, i.amount)}<br/>付款日期：${i.writeOffTime}<br/>实际账期：${i.actualAccountPeriod}<br/>`
                    }
                  })
                }
                break
              }
            }
            // console.log("params====>", params)
            if(res.length>142){
              return res
            }
            
          },
        },
        grid: {
          left: "40px",
          right: "120px",
          bottom: "80px",
          top: "60px"
        },
        xAxis: {
          name: "账单周期（年·月）",
          type: "category",
          splitLine: {
            show: true,
            interval: (index, v) => {
              let data = this.billingReportPaymentStatisticsDTOS[index]
              if (data.showSplitLine) {
                return true
              }
            },
            lineStyle: {
              color: "#ccc",
              type: "dotted",
            },
          },
          axisLabel: {
            interval: () => {
              if (dateRange === 1) {
                return 1
              } else if (dateRange === 2) {
                return 6
              } else {
                return "auto"
              }
            },
            rich: {
              a: {
                padding: 4,
                fontSize: 10,
              },
            },
            fontSize: 10,
          },
          data: billingReportPaymentStatisticsDTOS.map((v) => `${v.date}（${util.getCurrencySymbol(v.currency)}）`),
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          show: false
        },
        series: this.series.map((item) => ({
          ...item,
          type: "bar",
          stack: "总量",
          label: {
            show: true,
            color: "#000",
            position: "top",
            fontSize: 11,
            distance: 2,
            formatter:(v)=>{
              if (v.seriesIndex == writeLength+1){
                return this.totlePrice[v.dataIndex]
              }else {
                return ''
              }
            }
          },
          barWidth: dateRange === 3 ? "50%" : "16px",
        })),
        dataZoom: [
          {
            show: true,
            zoomLock: false,
            start: 50,
            end: 100,
            maxSpan: 50,
            bottom: 10,
            labelFormatter(index) {
              return `${dayjs(
                billingReportPaymentStatisticsDTOS[index].date
              ).format("MM-DD")}（${util.getCurrencySymbol(billingReportPaymentStatisticsDTOS[index].currency)}）`
            },
            textStyle: {
              fontSize: 10,
            },
          },
        ],
      })
      chartInstance.on("click", (data) => {
        console.log('====>',data)
        this.handleFeeConfirmationRoute(data)
      })
      return
    },
    handleFeeConfirmationRoute(data) {
      this.$router.push({
        name: "account-checking_index",
        params: { date: data.name }
      })
    },
    /**
     * @desc 生成月区间日期
     */
    genMonthRange(month = 1) {
      const now = dayjs()
      const prevDate = now.subtract(month, "month")
      return [prevDate.startOf('month').format("YYYY-MM-DD"), now.endOf('month').format("YYYY-MM-DD")]
    },
    // 设置 到期提示
    setMarklineData() {
      let data = this.billingReportPaymentStatisticsDTOS
      let arr = []
      data.forEach((v) => {
        if (v.unWriteOffRecord.length > 0) {
          arr.push({
            xAxis: `${v.billingCycle}（${util.getCurrencySymbol(v.currency)}）`,
            lineStyle: {
              color: "#fd7d2a",
              type: "dotted",
              opacity: 0,
            },
            label: {
              formatter: (e) => {
                let tpl = v.isOverdue
                  ? `{a|${v.dueDate}到期}\n{b|已逾期 }{c|${Math.abs(
                      v.daysOfOverdue
                    )}}{b|天}`
                  : `{a|${v.dueDate}到期}\n{b|还剩 }{c|${Math.abs(
                      v.daysOfOverdue
                    )}}{b|天}`
                return tpl
              },
              rich: {
                a: {
                  align: "center",
                  color: "#000",
                  fontSize: 11,
                },
                b: {
                  align: "center",
                  color: "#000",
                  marginLeft: "2px",
                },
                c: {
                  align: "center",
                  color: v.isOverdue ? "#f00" : "#52cc6f",
                  fontSize: 11,
                },
              },
            },
          })
        }
      })
      return arr
    },
  },
  watch: {
    dateRange: {
      handler() {
        this.renderChart()
      },
    },
  },
  beforeDestroy() {
    chartInstance = null
  },
}
</script>

<style lang="less">
.fee-confirm-component {
  .chart-head {
    display: flex;
  }
  .dateRange-select {
    top: 0;
    right: 66px;
  }
  .legend {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    .legend-item {
      display: inline-flex;
      align-items: center;
      margin-left: 20px;
      &:first-of-type {
        margin-left: 0px;
      }
    }
    .color-area {
      display: inline-block;
      width: 30px;
      height: 14px;
      border-radius: 4px;
      margin-right: 6px;
    }
  }
}
.rectangle {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #4f97eb;
}
#fee-confirm-chart {
  height: 350px;
}
</style>



// WEBPACK FOOTER //
// monthly-bill-chart.vue?5177bac6